<app-theme-option [categories]="themeOptions.optionsConfiguration[optionType].categories" [label]="themeOptions.optionsConfiguration[optionType].label" [information]="'PIXELS'" [limitedTo]="themeOptions.limitedTo(optionType)">
  <div app-theme-option-content>
    <app-show-details-option [showDetails]="showDetails" (sendShowDetails)="receiveShowDetails($event)">
      <div app-show-details-option-content>
        <app-number [value]="themeOptions.series(serieIndex)['weight']" (sendValue)="receiveValue($event)" [color]="color" [min]="1" [max]="5" [step]="0.5" [precision]="1"></app-number>
      </div>
    </app-show-details-option>
  </div>
</app-theme-option>

<div *ngIf="showDetails">
  <app-theme-option [categories]="themeOptions.optionsConfiguration[optionType].categoriesAndLabel" [label]="type | chart" [dark]="4" *ngFor="let type of themeOptions.limitedTo(optionType)">
    <div app-theme-option-content>
      <app-number [value]="themeOptions.series(serieIndex, type)['weight']" (sendValue)="receiveValue($event, type)" [color]="color" [min]="1" [max]="5" [step]="0.5" [precision]="1"></app-number>
    </div>
  </app-theme-option>
</div>